(function () {
  if (window.SHVideoEvents) return;

  var MAX_IDS = 50;
  var ID_RE = /^gid:\/\/shopify\/Metaobject\/\d+$/;
  var FLUSH_INTERVAL_MS = 30000;
  var IMPRESSION_THRESHOLD = 0.5;
  var IMPRESSION_DWELL_MS = 1000;

  var impressions = new Set();
  var plays = new Set();
  var completions = new Set();
  var addToCarts = new Set();
  // Separate from the flush buffers above: these track "already counted this
  // page view" so scrolling a card in/out of view repeatedly, or a video
  // firing multiple completion signals, only ever contributes once — even
  // across a flush that has already cleared the buffer being sent.
  var impressionedIds = new Set();
  var completedIds = new Set();

  function endpoint() {
    var base = window.shCommunityTrackUrl;
    return base ? base + '/events' : null;
  }

  function validId(id) {
    return typeof id === 'string' && ID_RE.test(id);
  }

  function addTo(set, id) {
    if (!validId(id)) return;
    if (set.size >= MAX_IDS) return;
    set.add(id);
  }

  // Picks the video to credit an add-to-cart to: the highest fraction of the
  // clip actually watched -- accumulated seconds from sessionStorage's
  // sh_video_watch map, divided by that clip's duration from
  // sh_video_duration (both written by assets/sh-video-card.js) -- falling
  // back to the last-touch sh_video value when no entry has a usable
  // duration. Comparing by fraction rather than raw accumulated seconds
  // avoids a long clip out-scoring a short clip that was watched in full
  // (e.g. a 70s clip needing only ~9s of play to beat an 8.8s clip watched
  // start to finish). Mirrors the identical selection in
  // attributeAddToCart() in snippets/sh-cart-drawer.liquid -- kept as an
  // independent copy here since this file can load before or entirely
  // without that inline script.
  function pickBestVideoId() {
    var best = null;
    var bestFraction = -1;
    try {
      var raw = sessionStorage.getItem('sh_video_watch');
      if (raw) {
        var map = JSON.parse(raw);
        var durationRaw = sessionStorage.getItem('sh_video_duration');
        var durationMap = durationRaw ? JSON.parse(durationRaw) : {};
        if (map && typeof map === 'object') {
          for (var id in map) {
            if (!Object.prototype.hasOwnProperty.call(map, id)) continue;
            var seconds = map[id];
            if (typeof seconds !== 'number') continue;
            var duration = durationMap && typeof durationMap[id] === 'number' && durationMap[id] > 0 ? durationMap[id] : 0;
            // No captured duration (e.g. a session already in progress when
            // this fix shipped) can't be fairly compared -- score it 0
            // rather than letting it win by default against a real fraction.
            var fraction = duration > 0 ? Math.min(1, seconds / duration) : 0;
            if (fraction > bestFraction) {
              bestFraction = fraction;
              best = id;
            }
          }
        }
      }
    } catch (e) {}
    if (best) return best;
    try { return sessionStorage.getItem('sh_video'); } catch (e) { return null; }
  }

  function flush() {
    var url = endpoint();
    if (!url) return;
    if (!impressions.size && !plays.size && !completions.size && !addToCarts.size) return;
    var payload = {
      impressions: Array.from(impressions),
      plays: Array.from(plays),
      completions: Array.from(completions),
      addToCarts: Array.from(addToCarts)
    };
    impressions.clear();
    plays.clear();
    completions.clear();
    addToCarts.clear();
    try {
      // A Blob typed application/json makes this a non-simple request and
      // triggers a CORS preflight, which sendBeacon cannot complete during
      // page unload -- the beacon silently vanishes. text/plain keeps it a
      // simple request; the worker JSON.parses the body itself.
      var blob = new Blob([JSON.stringify(payload)], { type: 'text/plain' });
      navigator.sendBeacon(url, blob);
    } catch (e) {}
  }

  var observer = null;
  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        var id = el.getAttribute('data-track-id');
        if (!id) return;
        if (entry.isIntersecting && entry.intersectionRatio >= IMPRESSION_THRESHOLD) {
          if (el.__shImpressionTimer) return;
          el.__shImpressionTimer = setTimeout(function () {
            el.__shImpressionTimer = null;
            if (!impressionedIds.has(id)) {
              impressionedIds.add(id);
              addTo(impressions, id);
            }
            observer.unobserve(el);
          }, IMPRESSION_DWELL_MS);
        } else if (el.__shImpressionTimer) {
          clearTimeout(el.__shImpressionTimer);
          el.__shImpressionTimer = null;
        }
      });
    }, { threshold: IMPRESSION_THRESHOLD });
    return observer;
  }

  // Called once per rendered video card (thumbnail), before playback --
  // registers it so we count "shown" separately from "played".
  function observeImpression(el, id) {
    if (!el || !validId(id)) return;
    if (impressionedIds.has(id)) return;
    getObserver().observe(el);
  }

  function trackPlay(id) {
    addTo(plays, id);
  }

  // Phase 2 attribution: fired once per add-to-cart. When called without an
  // explicit id, resolves it via pickBestVideoId() (highest watch time,
  // falling back to last-touch) instead of requiring the caller to do that
  // resolution itself.
  function trackAddToCart(id) {
    addTo(addToCarts, id || pickBestVideoId());
  }

  // Completion fires from either the real `ended` event or a 90%-of-duration
  // watch-time check, whichever comes first -- short clips often never fire
  // `ended` if the viewer scrolls away in the final second.
  function trackCompletion(id) {
    if (!validId(id)) return;
    if (completedIds.has(id)) return;
    completedIds.add(id);
    addTo(completions, id);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);
  setInterval(flush, FLUSH_INTERVAL_MS);

  window.SHVideoEvents = {
    observeImpression: observeImpression,
    trackPlay: trackPlay,
    trackCompletion: trackCompletion,
    trackAddToCart: trackAddToCart,
    flush: flush
  };
})();
